import { useMutation } from '@tanstack/react-query'

import { updateFreeeEndJournalEntryTransitionMode } from '@src/api'
import { DefaultApiPutFreeeEndJournalEntryTransitionModeRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useUpdateFreeeEndJournalEntryTransitionMode = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (
      params: DefaultApiPutFreeeEndJournalEntryTransitionModeRequest
    ) => updateFreeeEndJournalEntryTransitionMode(axiosInstance, params),
  })
}
